import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  excel_file: Yup.mixed().required("File is required")
});